export default __webpack_public_path__ + "static/felicitous-03089b8aea4d5f5ad748b7e8b48685fd.svg";